import { Group, Paper, Text, ThemeIcon } from "@mantine/core";
import { isMainAction, nodeWidth } from "../flowSettings";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import EmailNodeBody from "./EmailNodeBody";
import LinkedinNodeBody from "./LinkedinNodeBody";
import NodeAdvancedSettingsButton from "../components/NodeAdvancedSettingsButton";
import ConversationButton from "../components/ConversationButton";
import SmvNodeBody from "./SmvNodeBody";
import Linker from "./event/Linker";

const ActionNode = ({ data, id, nodeDetail, xPos, yPos }) => {
  const selectedNode = useFlowStore((s) => s.selectedNode);
  const setSelectedNode = useFlowStore((s) => s.setSelectedNode);
  const initialId = useFlowStore((s) => s.initialId);
  const linking = useFlowStore((s) => s.linking);

  const getAdditionalInfo = useMemo(() => {
    if (data?.actionType === "email") {
      return <EmailNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />;
    }
    if (data?.actionType.includes("linkedin") || data?.actionType === "sms") {
      return (
        <LinkedinNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />
      );
    }
    if (data?.actionType === "smv") {
      return <SmvNodeBody node_id={id} data={data} xPos={xPos} yPos={yPos} />;
    }
    return null;
  }, [data, id, xPos, yPos]);

  const handleHeadClick = ({ toAdvanced }) => {
    setSelectedNode({ data, id, toAdvanced: toAdvanced, x: xPos, y: yPos });
  };

  const isError = useMemo(() => {
    if (
      data?.actionType === "email" ||
      data?.actionType === "linkedin_message"
    ) {
      return !data?.model_id || (!data?.integration_id && !data?.pool_id);
    }
    if (
      data?.actionType === "linkedin_invitation" ||
      data?.actionType === "linkedin_visit"
    ) {
      return !data?.integration_id && !data?.pool_id;
    }
    if (data?.actionType === "sms") {
      return !data?.model_id;
    }
    if (data?.actionType === "smv") {
      return !data?.model_id;
    }
  }, [data?.actionType, data?.integration_id, data?.model_id, data?.pool_id]);

  return (
    <Paper
      w={nodeWidth}
      withBorder
      className={"action-node action"}
      p={"xs"}
      pt={6}
      pb={4}
      pos={"relative"}
      style={{
        borderColor: isError
          ? "var(--mantine-color-red-6)"
          : selectedNode?.id === id
          ? "var(--mantine-color-primary-6)"
          : "var(--mantine-color-primary-1)",
        boxShadow:
          selectedNode?.id === id
            ? "#00000021 0 4px 8px"
            : isError
            ? "#ff000018 0 2px 3px"
            : "#00000018 0 2px 3px",
      }}
      radius={"md"}
    >
      <Group
        className="head"
        onClick={isMainAction({ data, id }) ? handleHeadClick : undefined}
        style={{ cursor: isMainAction({ data, id }) ? "pointer" : "default" }}
        id={"node_head_" + id}
        gap={"xs"}
      >
        <ThemeIcon variant="light" color={nodeDetail.color} size={"md"}>
          {nodeDetail.icon}
        </ThemeIcon>
        <Text fz={"sm"} ta={"center"}>
          {nodeDetail.label}
        </Text>
        {nodeDetail?.sub_label && (
          <Text fz={"sm"} ta={"center"} fw={400} mb={4}>
            {nodeDetail.sub_label}
          </Text>
        )}
        {data?.source !== initialId && data?.actionType === "email" && (
          <ConversationButton data={data} id={id} />
        )}
        {data?.source !== initialId && isMainAction({ data, id }) && (
          <NodeAdvancedSettingsButton
            handleClick={(e) => {
              e.stopPropagation();
              handleHeadClick({ toAdvanced: true });
            }}
          />
        )}
      </Group>
      {getAdditionalInfo ? <Group mt={4}>{getAdditionalInfo}</Group> : null}

      {!linking && <Linker id={id} xPos={xPos} yPos={yPos} type={"action"} />}
    </Paper>
  );
};

export default ActionNode;
